import React from 'react';

import { Container, TextAutoMapping } from './styles';

export const AutoMapping: React.FC = () => {
  return (
    <Container>
      <TextAutoMapping>De/Para Automático</TextAutoMapping>
    </Container>
  );
};